// extracted by mini-css-extract-plugin
module.exports = {"approvePopup":"approvePopup__ZqZLa","card":"card__+9W4b","icon":"icon__+xX3Q","text":"text__hCDBd","button":"button__fxX7G"};